<template>
  <b-col>
       <loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="true"
      ></loading>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="generalcontainerplanes" v-if="portalLinea.idEstatusCarga === 6">
      <b-row>
        <b-col>
          <p style="color: #EEBA6D; font-weight: bolder; font-size: larger">El plan fue desactivado para portal comercial al igual que las renovaciones<br> automáticas.Resumen de las renovaciones automaticas desactivas.
          </p>
          <p style="font-size: larger">Se encontraron <span style="font-weight: bolder;">{{ detalleCancelacion.cantidadTicket}}</span> tickets.</p>
          <p style="font-size: larger"><span style="font-weight: bolder;">{{ detalleCancelacion.cantidadExistos }}</span> fueron desactivadas exitosamente</p>
          <p style="font-size: larger"><span style="font-weight: bolder;">{{ detalleCancelacion.cantidadError }}</span> fallaron por lo que tendrán que inactivarse manualmente con ayuda de Producto</p>
          <em class="excel_verde sombraModales" v-b-tooltip.hover.v-light.topright="'Descargar Información'" @click="exportarExcel()"></em>
          <p style="font-size: larger; color: rgb(141 141 141 / 80%);">Descarga los registros para más información</p>
        </b-col>
      </b-row>
    </div>
    <div class="generalcontainerplanes" v-if="portalLinea.idEstatusCarga === 5">
      <b-row>
        <b-col>
          <p style="color: #EEBA6D; font-weight: bolder; font-size: larger">El plan está programado para desactivarse esta noche. Al termino, se notificará a este correo<br>
            {{portalLinea.correoNoficacionPortalDesactivado}}
          </p>
        </b-col>
      </b-row>
    </div>
    <div class="generalcontainerplanes" v-if="portalLinea.idEstatusCarga === 7">
      <b-row>
        <b-col>
          <p style="color: #ff0000; font-weight: bolder; font-size: larger">Ha ocurrido un error durante la desactivación de la carga:<br>
            {{portalLinea.mensajeError}}
          </p>
        </b-col>
      </b-row>
    </div>
    <div class="etiqueta-flotante" v-if="portalLinea.idEstatusCargaCambioPrecio === 9">
      <b-row>
        <b-col>
          <b-card class="border-none" style="background-color: #f5f5f5; border: none !important;">
            <div class="text-center mx-auto w-75" style="color: #EEBA6D;">
                <span>
                  <strong>Se están actualizando las suscripciones. El plan se habilitará para edición al termino de la actualización.<br>
                    Al termino, se notificará a este correo.</strong>
                </span>
              <br><br>
              <span><strong>{{portalLinea.correoNoficacionPortalCambioPrecio}}</strong></span>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div class="generalcontainerplanes" v-if="portalLinea.idEstatusCarga === null">
      <b-button variant="primary" v-if="cargando && portalLinea != null" disabled>
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>

      <b-form v-on:submit.prevent="guardarPortalLinea" v-else>
        <b-form-checkbox
            v-model="compraLinea"
            v-if="portalLinea.idPlanPortal == null"
        >
          ¿Permitir comprar en linea?
        </b-form-checkbox>

        <div v-if="compraLinea">
          <b-row>
            <b-col>
              <b-card title="Información general">
                <b-form-group label="Imagen de grupos y módulos"
                              description="Debe escoger una imagen .png, maximo de dimensiones 700 x 750px">
                  <b-form-file
                      placeholder="Seleccionar imagen"
                      accept="image/png"
                      browse-text="Abrir"
                      v-on:change="seleccionarArchivo"
                      ref="inputFile"
                  >
                  </b-form-file>
                </b-form-group>
                <b-form-group label="Precio Cotizado: *">
                  <b-form-input
                      type="text"
                      v-model="portalLinea.precioNeto"
                      :state="portalLinea.precioNeto != null"
                      @keypress="$onlyNumber"
                      @keyup="$onlyNumber"
                      @paste="$onlyNumber"
                      @input="calcularMontosCalculadora()"
                      required
                  >
                  </b-form-input>
                  <b-form-invalid-feedback :state="portalLinea.precioNeto != null">
                    El campo es requerido
                  </b-form-invalid-feedback>
                </b-form-group>
                <strong>Precio Cotizado + IVA ({{portalLinea.iva * 100}} %):</strong> ${{precioIVA}}<br>
                <strong>Meses:</strong> {{portalLinea.mes}}<br>
                <strong>Comisión (%):</strong> {{portalLinea.comision}}<br>
                <strong>Monto de Comisión:</strong> ${{comision}}<br>
                <strong>MONT0 FIJO POR TRANSACCIÓN:</strong> ${{montofijoTransaccion}}<br>
                <strong>Precio del Plan</strong> ${{montoCobrado}}<br>
                <br>
                <b-form-group label="Modalidad de Pago:" label-for="value">
                  <v-select style="width: 50%; margin: 0 auto;" :options="modalidadesPago"
                            v-model="portalLinea.pagoRecurrente" label="modalidadPago"
                            placeholder="Selecciona una modalidad de pago (*)"  :reduce="(variable) => variable.value" id="value">
                    <span slot="no-options">No hay modalidades de pago</span>
                  </v-select>
                </b-form-group>
                 <b-form-group label="¿Requiere identificar al vendedor?" class="text-center">
                  <div style="margin-left: auto;margin-right: auto;width: 241px;">
                  <b-form-checkbox v-model="portalLinea.requiereVendedor" name="check-button" switch>
                  </b-form-checkbox>
                  </div>
                </b-form-group>
              <b-form-group label="Especifique el nombre con el que desea que aparezca este campo en el portal:" v-if="portalLinea.requiereVendedor === true">
                  <b-form-input
                      type="text"
                      v-model="portalLinea.nombreTipoVendedor"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback :state="portalLinea.nombreTipoVendedor != null && portalLinea.nombreTipoVendedor !== ''">
                    El campo es requerido
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Tipo de plan">
                  <b-form-radio-group
                      :options="opcionesTipoPlan"
                      v-model="portalLinea.tipoValidacion"
                      required
                  ></b-form-radio-group>
                  <b-form-invalid-feedback
                      :state="portalLinea.tipoValidacion != null"
                  >
                    Debe seleccionar una opción
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group v-if="portalLinea.tipoValidacion" label="¿Cuántas personas incluye el plan?">
                  <b-form-input
                      type="text"
                      v-model="portalLinea.numeroMaximo"
                      :state="+portalLinea.numeroMaximo > 1"
                      @keypress="$onlyNumberInt"
                      @keyup="$onlyNumberInt"
                      @paste="$onlyNumberInt"
                      required
                  >
                  </b-form-input>
                  <b-form-invalid-feedback
                      :state="+portalLinea.numeroMaximo > 1"
                  >
                    El campo es requerido
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                      :state="+portalLinea.numeroMaximo !== 1"
                  >
                    Usa un plan individual
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Desactivar Plan del Portal Comercial" class="text-center" v-if="portalLinea.registroActivoPlanPortal !== null && portalLinea.registroActivoPlanPortal !== undefined && portalLinea.idEstatusCargaCambioPrecio !== 9">
                  <div style="margin-left: auto;margin-right: auto;width: 241px;">
                  <b-form-checkbox name="check-button" v-model="portalLinea.registroActivoPlanPortal" @change="desactivarPlanPortalComercial()" switch>
                  </b-form-checkbox>
                  </div>
                </b-form-group>
              </b-card>
            </b-col>
            <b-col cols="6" class="h-100 d-flex flex-column">
              <div class="flex-fill">

                <b-card title="¿Cuenta con Upgrade?" style="max-height: 600px; overflow-y: auto">
                     <b-form-group label="Selecciona">
                        <b-form-select
                            v-model="portalLinea.esUgrade"
                            :options="selectedUpgrade.map(p => ({text: p.respuesta, value: p.value}))">
                        </b-form-select>
                      </b-form-group>
                <b-form-group  v-if="portalLinea.esUgrade">
                  <b-button variant="primary" size="sm" class="float-right"
                            @click="()=> portalLinea.idsPlanBase.push({idCuenta: null, planes: [], idPlan})">
                    <b-icon-plus-square/>
                  </b-button>
                </b-form-group>
                <template v-if="portalLinea.idsPlanBase.length > 0 && portalLinea.esUgrade">
                  <template v-for="planBase in portalLinea.idsPlanBase">
                    <b-card class="mt-3" :key="portalLinea.idsPlanBase.indexOf(planBase)">
                      <b-form-group label="Cuenta">
                        <b-form-select
                            @change="traerPlanes(planBase)"
                            v-model="planBase.idCuenta"
                            :options="cuentas">
                        </b-form-select>
                      </b-form-group>
                      <b-form-group label="Planes">
                        <b-form-select
                            v-if="planBase.planes.length > 0"
                            v-model="planBase.idPlan"
                            :options="planBase.planes.map(p => ({text: p.nombre, value: p.idPlan}))"
                        ></b-form-select>
                      </b-form-group>
                      <b-form-group>
                        <b-button variant="danger" size="sm" class="float-right"
                                  @click="()=> portalLinea.idsPlanBase = portalLinea.idsPlanBase.filter(pb => pb !== planBase)">
                          <b-icon-trash-fill/>
                        </b-button>
                      </b-form-group>
                    </b-card>
                  </template>
                </template>
                <template v-else>
                  <b-alert show variant="info"> No Hay planes base asignados</b-alert>
                </template>
              </b-card>
              </div>
              <div class="flex-fill mt-4">
                <b-card title="Historial de tareas - Actualización de precios"
                        style="max-height: 600px; overflow-y: auto">
                  <label class="text-justify d-flex align-items-start text-danger">
                    <b-icon icon="exclamation-circle" font-scale="1.7" style="color: #EEBA6D" class="mr-2 text-center"/>
                    Las suscripciones que no se actualicen exitosamente tendrán que ser actualizadas directamente en Stripe
                  </label>
                  <div class="contenedorTablaSinColor px-3">
                    <b-table :fields="fields" :items="listaCargaActualizacionPrecio">
                      <template #cell(idEstatusCarga)="data">
                        <span v-if="data.item.idEstatusCarga === 9" class="text-warning">
                          PROCESANDO
                        </span>
                        <span v-if="data.item.idEstatusCarga === 10" class="text-success">
                          COMPLETADO
                        </span>
                        <span v-if="data.item.idEstatusCarga === 11" class="text-danger">
                          ERROR
                        </span>
                      </template>

                      <template #cell(resumen)="data">
                        <span>
                          <b-icon
                              v-if="data.item.idEstatusCarga === 11"
                              icon="exclamation-circle"
                              variant="warning"
                              font-scale="2"
                              class="mr-1"
                          />
                         {{ data.item.exitosoSuscripcionesItem }} / {{ data.item.totalSuscripcionesItem }}
                          <span v-if="data.item.idEstatusCarga === 10">suscripciones exitosas</span>
                          <span v-if="data.item.idEstatusCarga === 9">suscripciones</span>
                        </span>
                      </template>

                      <template #cell(acciones)="data">
                        <div class="d-flex justify-content-center align-items-center">
                          <b-button
                              v-if="data.item.idEstatusCarga === 10"
                              class="sombraModales d-flex align-items-center justify-content-center"
                              variant="success"
                              style="cursor: pointer; width: 2.6rem; height: 2.0rem; border-radius: 50%;"
                              @click="traerPrecioStripeDetalle(data.item.idCargaCambioPrecio)"
                              v-b-tooltip.hover.v-light.topright="'Descargar Información'"
                          >
                      
                            <template>
                              <em class="excel icon-boton"></em>
                            </template>
                          </b-button>
                        </div>
                      </template>

                      <template #cell(fechaAlta)="row">
                        {{ row.item.fechaAlta | formatoFechaCorta }}
                      </template>

                      <template #cell(precioActualizado)="row">
                        {{ row.item.precioActualizado | moneda }}
                      </template>
                    </b-table>
                    <b-alert v-if="listaCargaActualizacionPrecio.length === 0" show variant="info"> No hay historial de tareas</b-alert>
                  </div>
                </b-card>
              </div>

            </b-col>
          </b-row>

        </div>

        <b-button
        v-if="$localStorageService.can('Plan_con_01_guar_linea') && portalLinea.idEstatusCargaCambioPrecio !== 9"
            class="mt-4"
            type="submit"
            variant="outline-primary"
            :disabled="loaderAcciones"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
              Guardando...
          </span>
        </b-button>
      </b-form>
    </div>
  </b-col>
</template>

<script>
import {PlanConvenioService, PortalLinea, PrecioStripeDetalle} from "../../../apiServices/planConvenio/PlanConvenioService";
import {PlanService} from "../../../apiServices/plan/PlanService";
import XLSX from "xlsx";

export default {
  name: "PortalLinea",
  planConvenioService: new PlanConvenioService(),
  planService: new PlanService(),
  props: {
    idPlan: {
      type: Number,
      require: true,
    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loading: false,
    portalLinea: new PortalLinea(),
    opcionesTipoPlan: [
      {text: "Individual", value: false},
      {text: "Grupal", value: true},
    ],
    cargando: false,
    loaderAcciones: false,
    compraLinea: false,
    cuentas: [],
    selected: [],
    selectedUpgrade:[{
      respuesta: 'SI' ,
      value: true,
    },
    {
      respuesta: 'NO',
      value: false
      }],
      precioIVA: 0,
      comision: 0,
      montoCobrado:0,
      planAux: null,
     montofijoTransaccion:0,
     detalleCancelacion: null,
    fieldsExcel: {
      "id ticket": "idTicket",
      "id certificado": "idCertificado",
      "suscripcion": "suscripcion",
      "suscripcionItem": "suscripcionItem",
      "fechaInactivacion": "fechaInactivacion"

    },
    parrafoAdvertencia: null,
    precioNetoOriginal: null,
    fields: [
      { key: "fechaAlta", label: "Fecha", sortable: true },
      { key: "idEstatusCarga", label: "Estado", sortable: true },
      { key: "idUsuario", label: "id_Usuario", sortable: true },
      { key: "precioActualizado", label: "Precio", sortable: true },
      { key: "resumen", label: "Resumen", sortable: true },
      "acciones"
    ],
    items: [
      {
        fecha: "01/01/2025",
        idEstado: 1,
        estado: "Procesando",
        idUsuario: 40912,
        precio: "$710",
        resumen: "13/20 suscripciones"
      },
      {
        fecha: "01/01/2025",
        idEstado: 2,
        estado: "Error",
        idUsuario: 40912,
        precio: "$710",
        resumen: ""
      },
      {
        fecha: "01/01/2025",
        idEstado: 3,
        estado: "Completo",
        idUsuario: 40912,
        precio: "$710",
        resumen: "13/20 suscripciones exitosas"
      }
    ],
    precioStripeDetalle: new PrecioStripeDetalle(),
    listaCargaActualizacionPrecio: [],
    loaderAccionesExcel: false,
    modalidadesPago: [
      {modalidadPago: "SUSCRIPCIÓN", value: true},
      {modalidadPago: "COBRO ÚNICO", value: false}
    ],
  }),

  created() {
    this.debug = this.$localStorageService.getDebug();
    this.buscarInformacionPlan();
    this.traerDatosPortalLinea();
    this.traerCuentas();
    this.obtenerDetallePlanDesactivado();
    this.traerCargaCambioPrecio();
  },
  watch: {
    'portalLinea.precioNeto'() {
      if (this.portalLinea.precioNeto < 0) {
        this.portalLinea.precioNeto = 0;
      }
    },
  },
  methods: {
    async modalPrecioNuevo() {
      this.parrafoAdvertencia = `
    <div class="text-gray-600 leading-relaxed mb-6 text-justify mt-3" style="font-size: medium">
      <p class="mb-4">Como hay un nuevo precio, debemos de realizar dos actividades:</p>
      <ul>
        <li style="font-size: smaller; list-style: disc !important;">Actualizaremos el precio de los productos en stripe para que las nuevas ventas utilicen estos precios. Se hará de inmediato.</li>
        <li style="font-size: smaller; list-style: disc !important;">Ejecutaremos una tarea para que se actualicen todas las suscripciones activas para que se renueven con este precio.</li>
      </ul>
      <p class="mt-4 text-xs text-gray-500">
        Si decides continuar, no podrás hacer ninguna edición del plan ni desactivar la tarea hasta que se haya concluido. ¿Estás seguro de que quieres continuar?
      </p>
    </div>
    `;

      return await this.$swal.fire({
        width: '700px',
        icon: "warning",
        title: "Detectamos que hay un nuevo precio",
        html: '<div class="container-fluid cew-9">' +
            '<div class="row justify-content-center">' +
            this.parrafoAdvertencia +
            '</div>' +
            '</div>',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'No, cancelar',
        confirmButtonColor: '#0e6ba9',
        cancelButtonColor: '#595959',
        customClass: {
          confirmButton: 'mr-1 mr-sm-5 rounded-pill',
          cancelButton: 'ml-1 ml-sm-5 rounded-pill'
        },
      });
    },
    traerCuentas() {
      this.$options.planConvenioService.obtenerCuentasConPlan().then(cuentas => {
        this.cuentas = cuentas.map(c => ({text: c.nombreCuenta, value: c.idCuenta}));
      })
    },
    traerPlanes(pb) {
      this.$options.planService.obtenerPlanesPorCuenta(pb).then(planes => {
        pb.planes = planes;
      })
    },
    traerDatosPortalLinea() {
      const params = {
        idPlan: this.idPlan
      }
      this.$options.planConvenioService.traerDatosPortalLinea(params)
          .then(portalLinea => {
            this.portalLinea = portalLinea;
            if (this.portalLinea.idPlanPortal) {
              this.compraLinea = true;
              this.calcularMontosCalculadora();
            }
            this.portalLinea.idsPlanBase = this.portalLinea.idsPlanBase.map(pb => ({...pb, planes: []}))
            this.portalLinea.idsPlanBase.forEach(this.traerPlanes)
            this.precioNetoOriginal = portalLinea.precioNeto;
          })
          .catch((err) => {
            this.errorTraerDatos(err);
          }).finally(() => {
        this.cargando = false;

      })
    },
    seleccionarArchivo(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files.length) {
        const file = new Blob([files[0]], {type: "image/png"});

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let img = new Image();
          img.src = evt.target.result;

          img.onload = () => {
            if (img.width > 700 || img.height > 750) {
              this.$swal({
                icon: "error",
                title: "La imagen excede del tamaño 700 x 750px",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            } else {
              const name = e.target.files[0].name;
              const lastDot = name.lastIndexOf(".");
              const fileName = name.substring(0, lastDot);
              const ext = name.substring(lastDot + 1);

              const formData = new FormData();
              formData.append("imagenBase", file, fileName);
              formData.append(
                  "usuarioLogeado",
                  this.$localStorageService.getIdUsuario()
              );
              formData.append("nombre", fileName);
              formData.append("ext", ext);

              this.enviarImagen(formData);
            }
          };
        };

        reader.onerror = (evt) => {
          console.error(evt);
        };
      }
    },
    enviarImagen(formData) {
      const url = this.$api + "empresas/imagen";
      let config = {
        header: {
          "Content-Type": "image/png",
        },
      };

      this.$http.post(url, formData, config).then((response) => {
        if (response.data.data) {
          this.portalLinea.idImagen = response.data.data;
        }
      });
    },
   async guardarPortalLinea() {
     this.portalLinea.precioActualizado = Number(this.portalLinea.precioNeto) !== Number(this.precioNetoOriginal);
      if (this.precioNetoOriginal != null && this.portalLinea.precioActualizado) {
        this.portalLinea.precioPlanAnterior = Number(this.precioNetoOriginal);
        this.portalLinea.precioPlanFinal = this.montoCobrado;
        const confirmPrecio = await this.modalPrecioNuevo();
        if (!confirmPrecio.isConfirmed) return;
        const confirmCorreo = await this.correoFinActualizacion();
        if (!confirmCorreo.isConfirmed) return;
      }
      if (this.planAux.idCanalSalida != 24){
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          html:'<p><strong>¿Estás de acuerdo con la configuración del Portal Comercial?</strong></p>' +
              '<br>' +
              '<p>El canal de salida seleccionado cambiará a Portal Comercial.</p>',
          showCancelButton: true,
          cancelButtonText:"Cancelar",
          confirmButtonText:"Confirmar"
        }).then((result) => {
              if (result.isConfirmed) {
                this.loaderAcciones = true;
                if (this.portalLinea.tipoValidacion === true && this.portalLinea.numeroMaximo <= 1) {
                  this.$swal({
                        icon: "warning",
                        text: "Para planes grupales debes seleccionar por lo menos 2 en el numero máximo de pacientes",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#0e6ba9"
                      }
                  )

                  this.loaderAcciones = false;
                  return;
                }
                if (this.portalLinea.requiereVendedor === true && (this.portalLinea.nombreTipoVendedor === null || this.portalLinea.nombreTipoVendedor === undefined || this.portalLinea.nombreTipoVendedor === '')) {
                  this.$swal({
                        icon: "warning",
                        text: "Debes Agregar el Nombre",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#0e6ba9"
                      }
                  )

                  this.loaderAcciones = false;
                  return;
                }
                this.$options.planConvenioService.guardarPortalLinea(this.traerDatos())
                    .then(() => {
                      this.$swal({
                        icon: "success",
                        text: "Se registró correctamente",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#0e6ba9",
                        onClose: () => {
                          location.reload();
                        },
                      });
                    })
                    .catch(() => {
                      this.$swal({
                        icon: "error",
                        text: "No se ha podido guardar los datos por favor verifica que hayas llenado todo el formulario incluido la imagen",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#0e6ba9",

                      });
                    })
                    .finally(() => {
                      this.$refs.inputFile.reset();
                      this.loaderAcciones = false;
                    });
              }
        });
      }else{
        this.loaderAcciones = true;
        if (this.portalLinea.tipoValidacion === true && this.portalLinea.numeroMaximo <= 1) {
          this.$swal({
                icon: "warning",
                text: "Para planes grupales debes seleccionar por lo menos 2 en el numero máximo de pacientes",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9"
              }
          )

          this.loaderAcciones = false;
          return;
        }
        if (this.portalLinea.requiereVendedor === true && (this.portalLinea.nombreTipoVendedor === null || this.portalLinea.nombreTipoVendedor === undefined || this.portalLinea.nombreTipoVendedor === '')) {
          this.$swal({
                icon: "warning",
                text: "Debes Agregar el Nombre",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9"
              }
          )

          this.loaderAcciones = false;
          return;
        }
        if (this.portalLinea.pagoRecurrente === null) {
          this.$swal({
                icon: "warning",
                text: "Debes seleccionar una modalidad de pago",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9"
              }
          )

          this.loaderAcciones = false;
          return;
        }
        this.$options.planConvenioService.guardarPortalLinea(this.traerDatos())
            .then(() => {
              this.$swal({
                icon: "success",
                text: "Se registró correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
                onClose: () => {
                  location.reload();
                },
              });
            })
            .catch(() => {
              this.$swal({
                icon: "error",
                text: "No se ha podido guardar los datos por favor verifica que hayas llenado todo el formulario incluido la imagen",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",

              });
            })
            .finally(() => {
              this.$refs.inputFile.reset();
              this.loaderAcciones = false;
            });
      }
    },
    traerDatos() {
      this.portalLinea.idPlan = this.idPlan
      this.portalLinea.usuarioLogueado = this.$localStorageService.getIdUsuario();
      return this.portalLinea;
    },
    calcularMontosCalculadora(){
      let iva = (this.portalLinea.precioNeto * this.portalLinea.iva);
      this.precioIVA = Math.ceil(iva + parseFloat(this.portalLinea.precioNeto));
      this.montofijoTransaccion = this.portalLinea.montofijoTransaccion;
      this.comision = Math.ceil(((this.portalLinea.comision / 100) * this.portalLinea.precioNeto))
      this.montoCobrado =  Math.ceil((this.precioIVA+this.comision))+this.montofijoTransaccion;
    },
    desactivarPlanPortalComercial(){
      this.$swal({
              icon: "warning",
              html: '<p><strong>¿Estás seguro de desactivar el plan del portal?</strong></p>'+
                '<p>·Ya no podrá ser comprado y se desactivarán todas las renovaciones automáticas para los pacientes que hayan adquirido este plan previamente.</br> ' +
                  'La vigencia actual seguirá corriendo hasta que termine. </p>',
              confirmButtonText: "sí, continuar",
              showCancelButton: true,
              confirmButtonColor: "#0e6ba9",
              denyButtonText:"cancelar",
              cancelButtonText: "No, cancelar",
            }
        )
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal({
                  html:
                      '<p><strong>La desactivación será programada para la noche. Te </br>' +
                          'notificaremos cuando haya concluido. Por favor déjanos '+
                              'tu correo para notificarte. </strong></br>'+
              '<p style="text-align:center;">Tu correo</p>',
                  confirmButtonText: "Desactivar Plan",
                  input: "text",
                  inputAttributes: {
                    autocapitalize: "off"
                  },
                  showCancelButton: true,
                  confirmButtonColor: "#0e6ba9",
                  denyButtonText: "cancelar",
                  cancelButtonText: "Cancelar",
              preConfirm: (email) => {
                if (!email) {
                  this.$swal.showValidationMessage('Por favor ingresa un correo electrónico');
                } else if (!this.validateEmail(email)) {
                  this.$swal.showValidationMessage('Por favor ingresa un correo electrónico válido');
                } else {
                  this.portalLinea.correoNoficacionPortalDesactivado = email;
                }
              }
                }).then((result) => {
              if (result.isConfirmed) {
                this.portalLinea.registroActivoPlanPortal = false;
                this.guardarPortalLinea();
              }else if(result.isDismissed) {
                this.portalLinea.registroActivoPlanPortal = true;
              }
            })
          }else if(result.isDismissed) {
             this.portalLinea.registroActivoPlanPortal = true;
          }
        })
    },
    buscarInformacionPlan() {
      const parametros = {idPlan: this.idPlan}
      this.$http.post(this.$api + 'planConvenio/obtener/plan', parametros).then(respuesta => {
            if (respuesta.data.data) {
              this.planAux = respuesta.data.data;
            }
          }
      )
    },
    obtenerDetallePlanDesactivado() {
      const parametros = {idPlan: this.idPlan}
      this.$http.post(this.$api + 'portalcomercial/cancelar/obtenerDetalleRenovacionesPlan', parametros).then(respuesta => {
            if (respuesta.data.data) {
              this.detalleCancelacion = respuesta.data.data;
            }
          }
      )
    },
    exportarExcel() {
      let data = XLSX.utils.json_to_sheet(this.detalleCancelacion.listaDetalleCancelacion)
      const workbook = XLSX.utils.book_new()
      const filename = 'reporte'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    async correoFinActualizacion() {
      return await this.$swal.fire({
        html:
            '<p><strong>Te notificaremos cuando haya concluido. Por favor ' +
            'Por favor déjanos tu correo para avisarte. '+
            '</strong></br>'+
            '<p style="text-align:center;">Tu correo</p>',
        confirmButtonText: "Actualizar precio",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonColor: "#0e6ba9",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "redondeo",
          confirmButton: "redondeo"
        },
        preConfirm: (email) => {
          if (!email) {
            this.$swal.showValidationMessage('Por favor ingresa un correo electrónico');
          } else if (!this.validateEmail(email)) {
            this.$swal.showValidationMessage('Por favor ingresa un correo electrónico válido');
          } else {
            this.portalLinea.correoNoficacionPortalCambioPrecio = email;
          }
        }
      });
    },
    traerCargaCambioPrecio() {
      const params = {idPlan: this.idPlan}
      this.$http.post(this.$api + 'cargaCambioPrecio/obtener', params).then(respuesta => {
        if (respuesta.data.data){
          this.listaCargaActualizacionPrecio = respuesta.data.data;
        }
      })
    },
    exportarExcelDetalle() {
      let listaExcel = [];
      this.precioStripeDetalle.forEach(element =>
    {
           let objeto ={
             "id_pacientes": element.idsPaciente,
             "suscripcionItem":  element.subscripcionItem,
             "email_customer_stripe ": element.emailCustomerStripe,
             "mensajeError": element.mensajeError,
             "descripcion_estatus_carga": element.descripcionEstatusCarga
           }
           listaExcel.push(objeto)
        });
      let data = XLSX.utils.json_to_sheet(listaExcel)
      const workbook = XLSX.utils.book_new()
      const filename = 'Historial-Actualizacion-precios'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
      this.loaderAccionesExcel = false;
      this.loading = false;
    },
    traerPrecioStripeDetalle(idCargaCambioPrecio) {
      this.loading = true;
      this.loaderAccionesExcel = true
      const params = {idCargaCambioPrecioStripe: idCargaCambioPrecio}
      this.$http.post(this.$api + 'cargaCambioPrecio/obtener/detallePrecio', params).then(respuesta => {
        if (respuesta.data.data) {
          this.precioStripeDetalle = respuesta.data.data;
          this.exportarExcelDetalle()
        }
      })
     .catch((err) => {
            this.errorTraerDatos(err);
          }).finally(() => {
        this.loaderAccionesExcel = false;
        
      })
    },
  },
  notifications: {
    errorTraerDatos: {
      type: "error",
      title: "Error",
      message: "Error al traer los datos",
    },
    errorEnviarDatos: {
      type: "error",
      title: "Error",
      message: "Error al enviar los datos",
    },
  },
};
</script>
<style scoped>
.sombraModales {
  filter: drop-shadow(2px 1px 4px rgba(0, 0, 0, 0.25));
}
.lista-modal{
  list-style: disc !important;
  list-style-position: outside;
  padding-left: .5rem;
}
.etiqueta-flotante {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 20;
}
</style>
